import React from "react";
import { Stack, FormControl, InputLabel, Select, MenuItem, Button, Chip } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setConfig } from "../../index";
import dayjs from "dayjs";
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

export const TableActions = () => {
    const dispatch = useDispatch();
    const filters = useSelector((store) => store.rosterArchive?.config?.filters);
    
    // Generate recent weeks (last 12 weeks)
    const recentWeeks = React.useMemo(() => {
        const weeks = [];
        for (let i = 0; i < 12; i++) {
            const date = dayjs().subtract(i, 'week');
            weeks.push({
                year: date.year(),
                week: date.isoWeek(),
                label: `Week ${date.isoWeek()} - ${date.format('MMM YYYY')}`,
                value: `${date.year()}-${date.isoWeek()}`
            });
        }
        return weeks;
    }, []);

    // Quick filter handlers
    const handleQuickFilter = (type) => () => {
        let newFilters = { ...filters };
        
        switch (type) {
            case 'current':
                newFilters.year = dayjs().year();
                newFilters.week = dayjs().isoWeek();
                break;
            case 'last':
                const lastWeek = dayjs().subtract(1, 'week');
                newFilters.year = lastWeek.year();
                newFilters.week = lastWeek.isoWeek();
                break;
            case 'clear':
                delete newFilters.year;
                delete newFilters.week;
                break;
            default:
                break;
        }
        
        dispatch(setConfig({
            filters: {
                ...newFilters,
                page: 0
            }
        }));
    };

    const handleWeekChange = (event) => {
        const value = event.target.value;
        
        if (!value) {
            dispatch(setConfig({
                filters: {
                    ...filters,
                    year: undefined,
                    week: undefined,
                    page: 0
                }
            }));
            return;
        }

        const [year, week] = value.split('-');
        dispatch(setConfig({
            filters: {
                ...filters,
                year: parseInt(year),
                week: parseInt(week),
                page: 0
            }
        }));
    };

    const selectedValue = filters?.year && filters?.week 
        ? `${filters.year}-${filters.week}` 
        : '';

    return (
        <Stack direction={"row"} spacing={2} alignItems="center">
            {/* Quick Filters */}
            <Button 
                size="small" 
                variant={!filters?.year && !filters?.week ? "contained" : "outlined"}
                onClick={handleQuickFilter('clear')}
            >
                All
            </Button>
            <Button 
                size="small" 
                variant={filters?.year === dayjs().year() && filters?.week === dayjs().isoWeek() ? "contained" : "outlined"}
                onClick={handleQuickFilter('current')}
            >
                Current Week
            </Button>
            <Button 
                size="small" 
                onClick={handleQuickFilter('last')}
            >
                Last Week
            </Button>

            {/* Combined Week Selector */}
            <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel>Select Week</InputLabel>
                <Select
                    value={selectedValue}
                    label="Select Week"
                    onChange={handleWeekChange}
                >
                    <MenuItem value="">
                        <em>All Weeks</em>
                    </MenuItem>
                    {recentWeeks.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                            {item.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {/* Active Filter Indicator */}
            {(filters?.year || filters?.week) && (
                <Chip 
                    label={`Filtered: Week ${filters.week} - ${filters.year}`}
                    onDelete={handleQuickFilter('clear')}
                    size="small"
                    color="primary"
                    variant="outlined"
                />
            )}
        </Stack>
    );
};

